export class ExpenseSummaryDto {
  id: string;
  description?: string;
  certificationId?: string;

  toString(): string {
    return this.description || this.id;
  }
}
